import React from 'react'
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import NotificationAccordion from '../../../../components/shared/modal/NotificationAccordion'
import { fontPalette } from '../../../../static/styles/global'

interface NotificationsCardProps {
  notifications: any[]
  displayedNotifications: any[]
  showAllNotifications: boolean
  setShowAllNotifications: (val: boolean) => void
  handlemarkasread: () => void
  notificationCount: number
  initialLength: number
  t: any
}

// We'll wrap NotificationAccordion to style it like the screenshot
// by injecting custom styling or rendering bullet dots in front of it.
const NotificationsCard = ({
  notifications,
  displayedNotifications,
  showAllNotifications,
  setShowAllNotifications,
  handlemarkasread,
  notificationCount,
  initialLength,
  t
}: NotificationsCardProps): JSX.Element => {
  
  // Custom dot colors based on index
  const dotColors = ['#ED8B22', '#A84499', '#9DD086']

  return (
    <View style={styles.card}>
      {/* Header */}
      <View style={styles.headerRow}>
        <View style={styles.iconTitleContainer}>
          <View style={[styles.iconCircle, { backgroundColor: '#ED8B22' }]}>
            <Ionicons name="notifications" size={16} color="white" />
          </View>
          <Text style={styles.headerTitle}>{t('notifications')}</Text>
        </View>

        {notifications?.length > 0 && (
          <TouchableOpacity onPress={handlemarkasread}>
            <Text style={styles.viewAllText}>{t('Mark all as read')}</Text>
          </TouchableOpacity>
        )}
      </View>

      {/* Notifications List */}
      <View style={styles.listContainer}>
        {displayedNotifications?.length > 0 ? (
          displayedNotifications.map((item, index) => {
            const color = dotColors[index % dotColors.length]
            return (
              <View key={index} style={styles.notificationItemWrapper}>
                {/* Left Dot Color bar/bullet */}
                <View style={[styles.bulletDot, { backgroundColor: color }]} />
                <View style={styles.accordionContainer}>
                  <NotificationAccordion item={item} />
                </View>
              </View>
            )
          })
        ) : (
          <Text style={styles.emptyText}>{t('No notifications available')}</Text>
        )}
      </View>

      {/* Footer View More/Less */}
      {notifications?.length > 3 && (
        <View style={styles.footerRow}>
          {showAllNotifications ? (
            <TouchableOpacity onPress={() => setShowAllNotifications(false)}>
              <Text style={styles.viewMoreLessBtn}>{t('View less')}</Text>
            </TouchableOpacity>
          ) : (
            <TouchableOpacity onPress={() => setShowAllNotifications(true)}>
              <Text style={styles.viewMoreLessBtn}>
                {t('View more')} ({notificationCount - initialLength})
              </Text>
            </TouchableOpacity>
          )}
        </View>
      )}
    </View>
  )
}

export default NotificationsCard

const styles = StyleSheet.create({
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 16,
    marginVertical: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  iconTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  iconCircle: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: fontPalette.primaryBold,
    color: '#0B495C'
  },
  viewAllText: {
    fontSize: 12,
    fontFamily: fontPalette.primaryBold,
    color: '#ED8B22'
  },
  listContainer: {
    marginTop: 4
  },
  notificationItemWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8
  },
  bulletDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginTop: 18, // aligns dot with accordion title
    marginLeft: 2,
    marginRight: 6
  },
  accordionContainer: {
    flex: 1
  },
  emptyText: {
    textAlign: 'center',
    fontSize: 14,
    color: '#777',
    paddingVertical: 12
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: 8,
    paddingLeft: 16
  },
  viewMoreLessBtn: {
    fontSize: 13,
    fontFamily: fontPalette.primaryBold,
    color: '#ED8B22'
  }
})
